import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { OrderModule } from 'ngx-order-pipe';
import { NgxPaginationModule } from 'ngx-pagination';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';

import { HeaderComponent } from './../header/header.component';
import { FooterComponent } from './../footer/footer.component';
import { SearchFilterPipe } from './../service/search-filter.pipe';
import { FilterPipe } from './../service/filter.pipe';

const materialModules = [
  MatButtonModule,
  MatIconModule,
  MatMenuModule,
  MatCardModule,
  MatInputModule,
  MatTabsModule,
  MatTableModule,
  MatAutocompleteModule,
  MatFormFieldModule,
  MatCheckboxModule,
  MatRadioModule,
  MatProgressBarModule,
  MatRadioModule,
  MatTreeModule,
  MatButtonToggleModule,
  MatGridListModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatSelectModule,
  MatSidenavModule,
];

@NgModule({
  declarations: [HeaderComponent,FooterComponent,SearchFilterPipe,FilterPipe],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    OrderModule,
    NgxPaginationModule,
    MatButtonModule,
    ...materialModules
  ],
  exports: [
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    OrderModule,
    NgxPaginationModule,
    ...materialModules,
    HeaderComponent,
    FooterComponent,
    SearchFilterPipe,
    FilterPipe
  ],
  providers: [DatePipe]
})

export class SharedModule { }
